import Config from './config.json';
var BUGSNAG_API_KEY = Config.bugsnagApiKey;
var ENVIRONMENT = Config.environment;
var IS_DEV = Config.environment === 'dev';
export default {
    BUGSNAG_API_KEY: BUGSNAG_API_KEY,
    ENVIRONMENT: ENVIRONMENT,
    IS_DEV: IS_DEV
};
